import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-logout',
  template: '<p>Logging out...</p>'
})
export class LogoutComponent implements OnInit {

  constructor(private msalService: MsalService, private router: Router) {}

  ngOnInit(): void {
    this.msalService.logoutRedirect(); 

    localStorage.clear(); 
    sessionStorage.clear(); 

    setTimeout(() => {
      this.router.navigate(['/']);
    }, 1000);
  }
}
